<!-- <div class="list-item-block glass-blurred-background drop-shadow" *ngFor="let contract of filteredContractList; let i=index;" (click)="openContract(contract.id)">
  <div class="pic center-content-vertical">
    <img class="svg-white vertical-middle list-avatar" src="./assets/imgs/avatar.svg">
  </div>
  <div class="name center-content-vertical">{{ contract.info }}</div>
  <div class="date center-content-vertical">{{ contract.payDate | date: 'dd-MM-yyyy' }}</div>
  <div class="total center-content-vertical">{{ contract.status }}</div>
  <div class="product center-content-vertical">{{ contract.contractId }}</div>
</div> -->
<div
        *ngIf="sessionService.user.permessions == sessionService.permessionTypes.ADMINISTRATOR"
        class="floating-btn drop-shadow"
        (click)="addPayment()"
>
    +
</div>
<ion-list>
    <ion-item-sliding *ngFor="let payment of filteredContractList;trackBy:identify" class=" ion-padding-bottom">
        <ion-item class="glass-blurred-background drop-shadow color-white" (click)="editPayment(payment)">
            <div [ngClass]='payment.status' ></div>
            <ion-grid>
                <ion-row>
                    <ion-col size="8">{{payment.user?.name}} {{payment.user?.lastname}}</ion-col>
                    <ion-col>{{payment.total| currency: 'EUR' }} </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="8">{{payment.typeEnum}}</ion-col>
                    <ion-col>{{payment.payDate | date : 'd/MM/YY'}}</ion-col>
                </ion-row>
            </ion-grid>
        </ion-item>
        <ion-item-options >
            <ion-item-option (click)="payed(payment)"  *ngIf="payment.status !=  b.PAGATO">
                Pagato
            </ion-item-option>
            <ion-item-option  color="danger" (click)="delete(payment)">
                Elimina
            </ion-item-option>
        </ion-item-options>
    </ion-item-sliding>
</ion-list>
<!--

<div class="flex-row">
    &lt;!&ndash;<div class="flex-1"><b>ID.N.</b></div>&ndash;&gt;
    <div class="flex-1"><b>Comm.</b></div>
    <div class="flex-1"><b>tip.</b></div>
    <div class="flex-1"><b>Commis.</b></div>
    <div class="flex-1"><b>stato.</b></div>
    <div class="flex-1"><b>Data</b></div>
</div>

&lt;!&ndash; <div *ngSwitchCase="'mensile'"> &ndash;&gt;
<div *ngFor="let payment of filteredContractList;trackBy:identify">
    <div class="flex-row">
        &lt;!&ndash; <div class="flex-1 ellipsis">
             <span class="fakeLink" (click)="openContract(payment.id)">{{ payment.id }}</span>
         </div>&ndash;&gt;
        <div class="flex-1">{{payment.user?.name}} {{payment.user?.lastname}}</div>
        <div class="flex-1"> {{payment.type}}</div>
        <div class="flex-1"> {{payment.total}}</div>

        <div [ngClass]="{'flex-1':true , 'green-text' : payment.status == 'Pagato', 'red-text' : payment.status == 'NonPagato'}">{{ payment.total | currency: 'EUR' }}</div>
        <div class="flex-1">{{ payment.payDate | date : 'd/MM/YY' }}</div>
    </div>
</div>


-->

